import { useState } from 'react';

import { Button } from '@mui/material';
import { X } from 'lucide-react';

import { LeadLostDialog } from '@modules/_shared/components/LeadLostDialog';
import { useLocale } from '@shared/hooks/locale';

type LeadLostButtonProps = {
  leadId: string;
  pipelineId?: string | null;
  agentId?: string | null;
  disabled?: boolean;
  currentStageId?: string | null;
  onStageUpdated?: (stageId: string) => void | Promise<void>;
};

export const LeadLostButton = ({
  leadId,
  pipelineId,
  agentId,
  disabled = false,
  currentStageId,
  onStageUpdated,
}: LeadLostButtonProps) => {
  const { t } = useLocale();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const isButtonDisabled = disabled || pipelineId == null;

  return (
    <>
      <Button
        variant="soft"
        color="error"
        startIcon={<X />}
        onClick={handleOpen}
        disabled={isButtonDisabled}
      >
        {t('Lost')}
      </Button>

      <LeadLostDialog
        open={open}
        onClose={handleClose}
        leadId={leadId}
        pipelineId={pipelineId}
        agentId={agentId}
        currentStageId={currentStageId}
        onStageUpdated={onStageUpdated}
      />
    </>
  );
};
